import React from 'react';

export interface MiniLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const MiniLogo: React.FC<MiniLogoProps> = ({ width = 30, height = 30, className = '' }) => {
  return (
    <div className={`mini-logo ${className}`} style={{ width, height }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 23 16"
        className="fill-logoColor"
      >
        <ellipse cx="1.91157" cy="2.20299" rx="1.91157" ry="1.91149" />
        <path d="M0.140625 5.9273C0.140625 5.47436 0.50782 5.10718 0.960778 5.10718H2.86484C3.3178 5.10718 3.68499 5.47436 3.68499 5.92729V15.1785C3.68499 15.6315 3.3178 15.9987 2.86484 15.9987H0.960778C0.50782 15.9987 0.140625 15.6315 0.140625 15.1785V5.9273Z" />
        <path d="M12.9964 13.8448C12.9964 13.8101 12.9682 13.7819 12.9334 13.7819C12.9053 13.7819 12.8807 13.8006 12.8725 13.8274C12.7837 14.1198 12.6484 14.3989 12.4664 14.6647C12.2751 14.9295 12.0396 15.1649 11.7599 15.3709C11.4949 15.5621 11.1858 15.7092 10.8325 15.8122C10.4939 15.9299 10.1407 15.9888 9.77267 15.9888C8.30067 15.9888 7.1893 15.4738 6.43858 14.444C5.68786 13.3994 5.3125 11.8914 5.3125 9.91988C5.3125 7.94841 5.68786 6.44774 6.43858 5.41787C7.1893 4.38799 8.30067 3.87306 9.77267 3.87306C10.5234 3.87306 11.1858 4.07903 11.7599 4.49098C12.3344 4.89294 12.7057 5.40696 12.8738 6.03305C12.8812 6.06052 12.9059 6.07993 12.9344 6.07993C12.9686 6.07993 12.9964 6.05217 12.9964 6.01793V0.410059C12.9964 0.18359 13.18 0 13.4064 0H15.8541C16.0806 0 16.2642 0.183589 16.2642 0.410059V15.3139C16.2642 15.5404 16.0806 15.724 15.8541 15.724H13.4064C13.18 15.724 12.9964 15.5404 12.9964 15.3139V13.8448ZM10.8546 13.3405C11.4728 13.3405 11.9807 13.1934 12.3781 12.8992C12.7903 12.5902 12.9964 12.1709 12.9964 11.6412V8.22059C12.9964 7.69094 12.7903 7.27899 12.3781 6.98474C11.9807 6.67578 11.4728 6.5213 10.8546 6.5213C10.2363 6.5213 9.72115 6.74199 9.30899 7.18336C8.91155 7.61002 8.71283 8.19117 8.71283 8.92679V10.935C8.71283 11.6707 8.91155 12.2592 9.30899 12.7005C9.72115 13.1272 10.2363 13.3405 10.8546 13.3405Z" />
        <ellipse cx="20.6733" cy="14.0863" rx="1.91157" ry="1.91149" />
      </svg>
    </div>
  );
};

export default MiniLogo;
